import TermsAndConditionsOfServicePageEn from './translation/ENTermsAndConditionsOfService';
import { useTranslation } from 'react-i18next';

export default function TermsAndConditionsOfServicePage() {
  const { i18n } = useTranslation();
  const renderTermsAndConditionsLanguage = () => {
    switch (i18n.language) {
      case 'it':
        return null;
      case 'en':
      default:
        return <TermsAndConditionsOfServicePageEn />;
    }
  };
  return <div>{renderTermsAndConditionsLanguage()}</div>;
}
